<section class="min-h-[2rem] flex flex-col md:flex-row justify-between items-center bg-background_banner p-4 md:p-4 gap-4">
  <!-- Sección del título -->
  <section class="text-center md:text-left">
      <p class="text-[24px] md:text-[28px] text-principal_title">
          {{ titleComponent }}
      </p>
  </section>

 

  <!-- Sección del perfil -->
   <section class="flex items-center justify-evenly w-[45%]">
    
    <button *ngIf="showButton" class="w-auto p-3 ml-4" (click)="openDialogRegister()">
      Registrar usuario
    </button>

    <img  *ngIf="showImgEps" [src]="imgLogin" alt="Imagen Eps" class="max-w-[188px] w-[50%]">

     <section class="w-full max-w-[220px] bg-color_box flex flex-col items-center justify-center rounded-xl p-4">
       
         <img src="../../../../assets/img/profile-png.webp" alt="imagen Usuario" class="w-[40%] md:w-[45%]">
         <p class="text-color_text_box cursor-pointer text-[16px] md:text-[18px]" (click)="toggleInfo()">
             {{ name }}
         </p>
   
         <div *ngIf="showInfo" class="mt-2 bg-color_box p-2 rounded-lg w-full text-center">
             <p class="text-color_text_box text-[12px] md:text-[14px] break-words"><strong>Email:</strong> {{ datainfoCredential.email }}</p>
             <p class="text-color_text_box text-[12px] md:text-[14px] break-words"><strong>Numero:</strong> {{ datainfoCredential.phoneNumber }}</p>
             <p class="text-color_text_box text-[14px] font-bold cursor-pointer" (click)="exit()">Salir</p>
         </div>
     </section>
   </section>
</section>



 <!-- <div class="relative w-full">
            <input 
              type="text" 
              placeholder="Buscar"
              class="w-full pl-4 pr-10 py-2 border rounded-lg shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 placeholder:text-principal"
            />
            <mat-icon 
              fontIcon="search" 
              class="absolute right-3 top-1/2 transform -translate-y-1/2 text-principal">
            </mat-icon>
          </div> -->